import { gql } from '@apollo/client'

export const Query = gql`
  query venueContacts(
    $companyId: ID!,
    $venueId: ID!,
    $filters: VenueContactFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    venues(companyId: $companyId, filters: { idEq: $venueId }, first: 1) {
      nodes {
        id
        venueContacts(filters: $filters, after: $after, before: $before, first: $first, last: $last) {
          nodes {
            id
            name
            email
            phone
            color
            contactType
          }
          pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
        }
      }
    }
  }
`
